import React from 'react';
import { Wine, PlusCircle, Search, Filter } from 'lucide-react';
import { Link } from 'react-router-dom';

const BlendsToolbar = ({ search, onSearchChange, filter, onFilterChange }) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="row align-items-center">
                    <div className="col-auto d-flex align-items-center">
                        <Wine size={24} className="me-2" />
                        <h5 className="mb-0">Wine Blends</h5>
                    </div>
                    
                    <div className="col">
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search blends..."
                                value={search}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                            <select 
                                className="form-select" 
                                style={{ maxWidth: '150px' }} 
                                value={filter}
                                onChange={(e) => onFilterChange(e.target.value)}
                            >
                                <option value="all">All Blends</option>
                                <option value="draft">Drafts</option>
                                <option value="finalized">Finalized</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="col-auto">
                        <Link 
                            to="/blends/new" 
                            className="btn btn-outline-primary"
                        >
                            <PlusCircle size={18} className="me-2" />
                            Create New Blend
                        </Link>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
                
                .input-group-text {
                    background-color: white;
                    border-right: none;
                }
                
                .input-group .form-control {
                    border-left: none;
                }
                
                .input-group .form-control:focus {
                    border-left: none;
                    box-shadow: none;
                }
            `}</style>
        </div>
    );
};

export default BlendsToolbar;